import { render, staticRenderFns } from "./IconCheckedAlt.vue?vue&type=template&id=2945f602&"
import script from "./IconCheckedAlt.vue?vue&type=script&lang=js&"
export * from "./IconCheckedAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports